import { toast, loading } from '@/shared/utils/UIHelper'
import ClienteRHRepository from '@/shared/http/repositories/business/clientrh.js'
import ObraRepository from '@/shared/http/repositories/business/obra.js'
import ExpenseAttachmentLogRepository from '@/shared/http/repositories/business/expenseattachmentlog'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import TermlogAttachedRepository from '@/shared/http/repositories/business/termlogattached.js'
import LotDiscountExpenseRepository from '@/shared/http/repositories/business/lotdiscountexpense.js'

const BoardMixin = {
  methods: {
    onSearchClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    GetDespesaDescontoLog (value) {
      loading.push()
      LotDiscountExpenseRepository.GetByName(value)
        .then(Response => {
          this.$refs.descontoLog.data = Response.data
          loading.close()
        })
        .catch(Error => {
          console.log(Error)
          loading.close()
        })
    },
    onChangeCodeDespesaDescontoLog (value) {
      loading.push()
      LotDiscountExpenseRepository.GetByCode(value)
        .then(Response => {
          this.$refs.descontoLog.setValue(Response.data)
          loading.close()
        })
        .catch(Error => {
          console.log(Error)
          loading.close()
        })
    },
    GetTermoLog (value) {
      loading.push()
      TermlogAttachedRepository.GetByName(value, this.CompanySelected)
        .then(Response => {
          this.$refs.termoLoteTypehead.data = Response.data
          loading.close()
        })
        .catch(Error => {
          console.log(Error)
          loading.close()
        })
    },
    onChangeCodeDespesaLog (value) {
      loading.push()
      ExpenseAttachmentLogRepository.GetByLote(value, this.CompanySelected)
        .then(Response => {
          this.$refs.despesaLog.setValue(Response.data)
          loading.close()
        })
        .catch(Error => {
          console.log(Error)
          loading.close()
        })
    },
    onChangeCodeClienteRH (value) {
      loading.push()
      ClienteRHRepository.GetByCode(this.CompanySelected, value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.clienteRHTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    GetDespesaLog (name) {
      loading.push()
      ExpenseAttachmentLogRepository.GetByName(name, this.CompanySelected)
        .then(Response => {
          this.$refs.despesaLog.data = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onChangeCodeTermoLog (value) {
      loading.push()
      TermlogAttachedRepository.GetByLote(value, this.CompanySelected)
        .then(Response => {
          this.$refs.termoLoteTypehead.setValue(Response.data)
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onSearchObra (value) {
      if (value) {
        loading.push()
        ObraRepository.GetAllByName(this.CompanySelected, value, 50, 1)
          .then((response) => {
            if (response.data.code > 0) {
              this.$refs.obraRHTypeahead.data = response.data.data
            }
            loading.close()
          })
          .catch((err) => {
            console.log(err)
            loading.close()
          })
      }
    },
    onSearchObraId (value) {
      if (value) {
        loading.push()
        ObraRepository.GetById(value)
          .then((response) => {
            this.$refs.obraRHTypeahead.setValue(response.data)
            loading.close()
          })
          .catch((err) => {
            console.log(err)
            loading.close()
          })
      }
    },
    onChangeCodeObra (value) {
      if (value) {
        loading.push()
        ObraRepository.GetAllByCode(this.CompanySelected, encodeURIComponent(value))
          .then((response) => {
            if (response.data.code > 0) {
              if (response.data.data) {
                this.$refs.obraRHTypeahead.setValue(response.data.data[0], 'referencia')
              }
            }
            loading.close()
          }).catch(err => {
            console.log(err)
            loading.close()
          })
      }
    },
    onSearchResponsavel (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeResponsavel (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.responsavelTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onSearchFavorecido (value) {
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.data = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFavorecido (value) {
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeahead.setValue(response.data.data)
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          loading.close()
        })
    },
    onDownloadExcel (response) {
      const obj = response.data.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      toast.success('Arquivo gerado com sucesso!')
      loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    }
  }
}

export default BoardMixin



// WEBPACK FOOTER //
// ./src/views/private/finance/accountability/components/travelExpenseTab/components/travelexpensezpag/mixins/ExpenseMixin.js